var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-section",style:({ height: _vm.computedHeight }),attrs:{"id":"top-section"}},[_c('h3',[_vm._v("Welcome to AntTV – your ultimate app for short dramas!")]),_c('div',{staticStyle:{"margin-top":"30px"}},[_c('download-buttom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }